// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'


export const getData = createAsyncThunk('appInvoice/getData', async (params, thunkAPI) => {
    try {
        
        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller } = params

        // if (import.meta.env.DEV) {
        //     console.log(`Called by ${caller}`)
        // }

        let data
        let tempIsDataLoaded

        if (!state.invoice2.isDataLoaded) {
            
            const response = await axios.get('/apps/invoice2/invoices', params)

            if (response.status !== 200) {
                throw new Error('Fetch response error at getData', response.statusText)
            }
            // if (import.meta.env.DEV) {
            //     console.log('API call to /Accounts/GetAccountListF01')
            // }

            data = response.data.allData
            tempIsDataLoaded = true
        } else {

            data = state.invoice2.allData
            tempIsDataLoaded = state.invoice2.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:

        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            if (a[sortColumn]) {
                return a[sortColumn] < b[sortColumn] ? -1 : 1
            } else {
                const splitColumn = sortColumn.split('.')
                const columnA = a[splitColumn[0]][splitColumn[1]]
                const columnB = b[splitColumn[0]][splitColumn[1]]
                return columnA < columnB ? -1 : 1
            }
        })

        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            invoice2 => { 
                return ((invoice2.client.name.toLowerCase().includes(queryLowered) ||
                    invoice2.client.contact.toLowerCase().includes(queryLowered) ||
                    invoice2.client.companyEmail.toLowerCase().includes(queryLowered)) 
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message
        return thunkAPI.rejectWithValue(errorMessage)  

    }
    
})

export const appInvoiceSlice = createSlice({
    name: 'appInvoiceSlice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0, // Originally 1
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getData.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getData.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getData as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

export const deleteInvoice = createAsyncThunk('appInvoice/deleteInvoice', async (id, { dispatch, getState }) => {
    await axios.delete('/apps/invoice/delete', { id })
    await dispatch(getData(getState().invoice.params))
    return id
  })

// Export actions
export const { setIsDataLoaded } = appInvoiceSlice.actions

// Export reducer
export default appInvoiceSlice.reducer
